var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tappable',_vm._g(_vm._b({class:_vm.classNames,attrs:{"activeEffectDelay":_vm.isIOS ? 0 : _vm.ACTIVE_EFFECT_DELAY}},'Tappable',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"TabsItem__in"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }